import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { Flex } from '../Flex/Flex.mjs';

const CardHeaderWrapper = styled(Flex) `
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral150};
`;
const CardHeader = (props) => {
    return jsx(CardHeaderWrapper, { position: "relative", justifyContent: "center", ...props });
};

export { CardHeader };
